import { Magnetic } from "./magnetic.js";

export function initMagnetic() {
  document.querySelectorAll(".magnetic").forEach((el) => {
    new Magnetic(el);
  });
}